import baseTheme from './baseTheme';

export { baseTheme };
